(function () {
  function playVideo(video) {
    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(function () {});
    }
  }

  function initSection(root) {
    var videos = root.querySelectorAll('.how-it-works__media video');
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.addEventListener('canplay', function () {
        playVideo(video);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              playVideo(entry.target);
            }
          });
        },
        { threshold: 0.2 }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-how-it-works]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
